/* 

Component Section One Home

*/

import ComponentSectionOneHome from './ComponentSectionOneHome.jsx';

export default ComponentSectionOneHome;